import { api } from "../api";
import ActionType from "../utils/customTypes";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class AnnouncementService extends api {

    private static classInstance?: AnnouncementService;
        
    constructor(token: string, type: ActionType) {
        super( process.env.REACT_APP_BASE_URL,token);    
    } 
     
    public static getInstance() {
        let token = cookies.get('stkc');
        if (!this.classInstance) {
            this.classInstance = new AnnouncementService(token!==undefined?token:'', 'GET');
        }
        
        return this.classInstance;
    }   
     
    public getActiveAnnoucements = () => this.instance.post('/announcements/get-active-announcements').then(response => {
        if (response) {
            return response;
        }
    
    }).catch((error: any) => {
        return Promise.reject(error);
    });

    public getAnnouncements = () => this.instance.post('/announcements/get-announcements').then(response => {
        if (response) {
            return response;
        }
    
    }).catch((error: any) => {
        return Promise.reject(error);
    });
    
   

}